<header>
  <h1>
    Page Admin
    <button (click)="addListing()" color="primary" mat-mini-fab matTooltip="Create page.">
      <mat-icon>add</mat-icon>
    </button>
  </h1>
  <search-text (search)="setSearch($event)"></search-text>
</header>
<section class="filters">
  <mat-button-toggle-group #typeFilter="matButtonToggleGroup" (change)="setType(typeFilter.value)" [(value)]="toggleVal">
    <mat-button-toggle disabled value="*"> Type: </mat-button-toggle>
    <mat-button-toggle value="all" checked>
      <mat-icon>list</mat-icon>
      All
    </mat-button-toggle>
    @for (type of typeOptions; track type) {
      <mat-button-toggle [value]="type.type">
        <mat-icon>{{ type.icon }}</mat-icon>
        {{ type.title }}
      </mat-button-toggle>
    }
  </mat-button-toggle-group>
  <section>
    <mat-button-toggle-group #statusFilter="matButtonToggleGroup" (change)="setStatus(statusFilter.value)"
      value="{{status}}">
      <mat-button-toggle disabled value="*"> Status: </mat-button-toggle>
      <mat-button-toggle value="live">
        <mat-icon>list</mat-icon>
        Live
      </mat-button-toggle>
      <mat-button-toggle value="null">
        <mat-icon>list</mat-icon>
        All
      </mat-button-toggle>
      <mat-button-toggle value="disabled">
        <mat-icon>list</mat-icon>
        Disabled
      </mat-button-toggle>
      <mat-button-toggle value="expired">
        <mat-icon>list</mat-icon>
        Expired
      </mat-button-toggle>
    </mat-button-toggle-group>
  </section>
</section>
<div class="filtersSection">
  @if (hasPermisson('organisation-admin')) {
    <section class="filters filter-select">
      <mat-button-toggle disabled value="*"> Organisation: </mat-button-toggle>
    <mat-select (selectionChange)="setOrgFilter($event.value)" style="
        background-color: white;
        padding: 10px 20px;
        display: flex;
        align-items: center;
      " [(value)]="orgSelected">
        @if (isAdmin) {
          <mat-option value="all">All</mat-option>
        }
        @for (org of userOrgs; track org) {
          <mat-option [value]="org.company_id">{{org.title}}</mat-option>
        }
      </mat-select>
    </section>
  }
  @if (hasPermisson('admin') || hasPermisson('organisation-admin')) {
    <section class="filters filter-select">
      <mat-button-toggle disabled value="*"> Category: </mat-button-toggle>
    <mat-select (selectionChange)="setCatFilter($event.value)" style="
        background-color: white;
        padding: 10px 20px;
        display: flex;
        align-items: center;
      " [(value)]="catSelected">
        <mat-option value="all">All</mat-option>
        @for (category of categories; track category) {
          <mat-option [value]="category.id">{{category.title}}</mat-option>
        }
      </mat-select>
    </section>
  }
</div>
<section>
  @if (loading) {
    <mat-card class="loading">
      <mat-card-content>
        <mat-icon>autorenew</mat-icon>
        Loading&hellip;
      </mat-card-content>
    </mat-card>
  }
  @if (!loading) {
    @if (!Listings?.length) {
      <mat-card class="no-results">
        <mat-card-content>
          <mat-icon>sentiment_dissatisfied</mat-icon>
          No pages found.
        </mat-card-content>
      </mat-card>
    }
    @if (!!Listings?.length) {
      @for (Listing of Listings; track Listing) {
        <mat-card class="listing">
          <mat-card-header>
            <mat-toolbar>
              <span [title]="Listing.title" class="title">{{ Listing.title }}</span>
              <div class="info-container">
                <span class="listingId">Listing ID: {{Listing.id}}</span>
                <span class="company">Organisation: {{Listing.branch_id ? Listing.branch_name :
                Listing.company_name}}</span>
              </div>
            </mat-toolbar>
          </mat-card-header>
          <mat-card-content align="end">
            <button mat-button matTooltip="Cohorts" (click)="listCohorts(Listing)">
              <mat-icon>people</mat-icon> Cohorts
            </button>
            @if (!Listing?.branch_id) {
              <button (click)="getOffers(Listing)" mat-button matTooltip="Offers">
                <mat-icon>star_rate</mat-icon>
                App Offers
              </button>
            }
            <button (click)="deleteListing(Listing)" mat-button matTooltip="Delete Listing">
              <mat-icon>delete</mat-icon>
              Delete
            </button>
            <button (click)="listCategories(Listing)" mat-button matTooltip="View page categories">
              <mat-icon>bookmark</mat-icon>
              Categories
            </button>
            @if (hasPermisson('event-admin')) {
              <button (click)="listTickets(Listing)" [disabled]="Listing.features['ballot'] || Listing.features['product']" mat-button
                matTooltip="View page tickets">
                <mat-icon>payment</mat-icon>
                Tickets
              </button>
              <button (click)="listProducts(Listing)" [disabled]="Listing?.features['ballot']|| Listing?.features['ticket']"
                mat-button matTooltip="View products">
                <mat-icon>shopping_cart</mat-icon>
                Products
              </button>
            }
            @if (!Listing?.branch_id) {
              <button (click)="enableListing(Listing)" [disabled]="processListingId === Listing.id"
                mat-button matTooltip="{{ Listing.enabled && 'Disable' || 'Enable' }} page">
                <mat-icon>{{ Listing.enabled && 'check_box' || 'check_box_outline_blank' }}
                </mat-icon>
                {{ Listing.enabled && 'Enabled' || 'Disabled' }}
                @if (processListingId === Listing.id) {
                  <mat-spinner diameter="20"></mat-spinner>
                }
              </button>
            }
            @if (Listing?.branch_id) {
              <button (click)="copyLink(Listing)" [disabled]="processListingId === Listing.id" mat-button
                matTooltip="Copy listing link">
                <mat-icon>copy_all </mat-icon>
                Copy Link
              </button>
            }
            <button (click)="listAuditLog(Listing)" mat-button matTooltip="View page audit log" [jlpFeatureActive]="'auditLog'">
              <mat-icon>analytics</mat-icon>
              Audit Log
            </button>
            <button (click)="createPreviewLink(Listing)" mat-button matTooltip="View page">
              <mat-icon>visibility</mat-icon>
              View
            </button>
            <button (click)="duplicateListing(Listing)" mat-button matTooltip="Duplicate listing">
              <mat-icon>file_copy</mat-icon>
              Duplicate Listing
            </button>
            <button (click)="getRelatedContent(Listing)" mat-button matTooltip="Related content">
              <mat-icon>link</mat-icon>
              Related Content
            </button>
            <button (click)="editListing(Listing)" mat-button matTooltip="Edit listing">
              <mat-icon>edit</mat-icon>
              Edit
            </button>
            <button (click)="listCarousel(Listing)" [disabled]="!Listing.id" mat-button matTooltip="View page images">
              <mat-icon>photo_library</mat-icon>
              Images
            </button>
            <button (click)="listProductInfo(Listing)" mat-button matTooltip="View page extra info">
              <mat-icon>info_outline</mat-icon>
              Extra Info
            </button>
            @if (!Listing.enabled) {
              <button (click)="createTempUrl(Listing)" mat-button
                matTooltip="Create a temporary URL for this listing">
                <mat-icon>add_link</mat-icon>
                Temporary Link
              </button>
            }
          </mat-card-content>
          @if (Listing.variants?.length > 0) {
            <mat-card-actions class="variantsSection">
              <div class="variantsHeader">
                <h4>
                  <b>Location</b>
                </h4>
                <h4>
                  <b>Date</b>
                </h4>
              </div>
              @for (variant of Listing.variants; track variant) {
                <div class="variantsContent">
                  <p>{{variant.location}}</p>
                  <p>{{variant.date}}</p>
                </div>
              }
            </mat-card-actions>
          }
        </mat-card>
      }
    }
  }
  @if (PageEvent) {
    <mat-paginator (page)="DataSource.loadWithPageEvent($event)" [length]="PageEvent.length"
    [pageIndex]="PageEvent.pageIndex" [pageSize]="PageEvent.pageSize"></mat-paginator>
  }
</section>